import React from "react";

const MapPointerIcon = (props) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="19.328" viewBox="0 0 14 19.328"><path d="M77.573 0a7.008 7.008 0 0 0-7 7c0 4.79 6.264 11.822 6.531 12.119a.631.631 0 0 0 .938 0c.267-.3 6.531-7.329 6.531-12.119a7.008 7.008 0 0 0-7-7zm0 10.522a3.522 3.522 0 1 1 3.522-3.522 3.526 3.526 0 0 1-3.522 3.522z" transform="translate(-70.573 0)" fill={props.fill} /></svg>
    )
}

export default MapPointerIcon;
